import { formatValue, getAddedOrDeletedMessage, getValClassName, isItemAdded, renderEdition } from './common';

import type { ChangelogRule } from './types';

export const GENERAL_ORDER = 0;

export const generalRules: ChangelogRule[] = [
  {
    format: (change, context) =>
      renderEdition(
        `${context.entity} ${context.formatMessage({ defaultMessage: 'countries', id: 'changelogModal.message.countries' })}`,
        formatValue(change.lhs),
        formatValue(change.rhs),
        context
      ),
    order: GENERAL_ORDER + 1,
    regex: /^E\.countries(\.|$)/,
    section: 'general'
  },
  {
    format: (change, context) =>
      renderEdition(
        `${context.entity} ${context.formatMessage({ defaultMessage: 'number', id: 'changelogModal.message.number' })}`,
        formatValue(change.lhs),
        formatValue(change.rhs),
        context
      ),
    order: GENERAL_ORDER + 1,
    regex: /^E\.ioNumber$/,
    section: 'general'
  },
  {
    format: (change, { entity, formatMessage }) => (
      <div className={getValClassName('edit')}>
        <b>{`${entity} ${formatMessage({ defaultMessage: 'countries', id: 'changelogModal.message.countries' })} `}</b>
        {getAddedOrDeletedMessage(isItemAdded(change), formatMessage)}
      </div>
    ),
    order: GENERAL_ORDER + 1,
    regex: /^A\.countries$/,
    section: 'general'
  },
  {
    format: (change, { entity, formatMessage }) => (
      <div className={getValClassName(change.rhs ? 'add' : 'delete')}>
        <b>{`${entity} ${formatMessage({ defaultMessage: 'Updating status', id: 'changelogModal.message.updating' })}`}</b>
        {` ${formatMessage({ defaultMessage: 'was', id: 'changelogModal.message.was' })} `}
        <b>{formatValue(change.rhs)}</b>
      </div>
    ),
    order: GENERAL_ORDER + 1,
    regex: /^E\.launching$/,
    section: 'general'
  },
  {
    format: (_change, { entity, formatMessage }) => (
      <div className={getValClassName('add')}>
        <b>{`${entity} ${formatMessage({ defaultMessage: 'started', id: 'changelogModal.message.started' })}`}</b>
      </div>
    ),
    order: GENERAL_ORDER + 1,
    regex: /^E\.completed$/,
    section: 'general'
  },
  {
    format: (change, context) =>
      renderEdition(
        `${context.entity} ${context.formatMessage({ defaultMessage: 'name', id: 'changelogModal.message.name' })}`,
        formatValue(change.lhs),
        formatValue(change.rhs),
        context
      ),
    order: GENERAL_ORDER + 2,
    regex: /^E\.name$/,
    section: 'general'
  },
  {
    // The whole targeting is stored when it is first set: its detail is not relevant
    format: (_change, { entity, formatMessage }) => (
      <div className={getValClassName('edit')}>
        <b>{`${entity} ${formatMessage({ defaultMessage: 'targeting configured', id: 'changelogModal.message.targetingConfigured' })}`}</b>
      </div>
    ),
    order: GENERAL_ORDER + 3,
    regex: /^N\.targeting$/,
    section: 'general'
  }
];
